import { render, staticRenderFns } from "./create_account_form.vue?vue&type=template&id=fb68f790&scoped=true&"
import script from "./create_account_form.vue?vue&type=script&lang=js&"
export * from "./create_account_form.vue?vue&type=script&lang=js&"
import style0 from "./create_account_form.vue?vue&type=style&index=0&id=fb68f790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb68f790",
  null
  
)

export default component.exports